/**
 * Life Blueprint V2.9.9 — M02 ReferenceData · Controlled Batch 07-1
 *   DB_24节气 (Sheet27 dependency, A4:Y115, 111 audited year rows)
 *   DB_月令权重 (Sheet28 minimum dependency, A1:H13, 12 audited rows)
 *
 * ─────────────────────────────────────────────────────────────────────────────
 * SCOPE (STRICT — Batch07-1 ONLY)
 *   • Two new AUTHORITATIVE ReferenceData sources for the Final PoC.
 *   • Batch07-2 (B85:E88 + M04) and Batch07-3 (PoC composer + E2E) NOT
 *     started. UI unchanged. V2.9.9 production pipeline NOT connected.
 *
 * ISOLATION
 *   Does NOT write into `src/engine/referenceData.js` production
 *   registry. Does NOT modify M02 Batch01–06 or M03 Sheet27 Batch01–07.
 *
 * UNICODE / DATA POLICY
 *   Chinese literals built from AscW code points via `String.fromCodePoint`.
 *   DB_24节气: authoritative Value2 extraction from
 *     Life_Blueprint_华夏版_V2_9_9_R2_兼容性修复候选版.xlsx
 *     SHA-256 6d97148d708a3dbc84bcec9bdce9facdb815891de077036c9fc118a75e86d500.
 *     All `_时` cells are EXCEL-BLANK across all 111 rows — preserved
 *     as literal empty string "". The Excel formula chain
 *       IFERROR(VALUE(LEFT(D<row>,2))/24+VALUE(MID(D<row>,4,2))/1440, 0)
 *     therefore contributes a deterministic +0 offset for every row.
 *   DB_月令权重: 12 audited rows, columns A:F engine, G:H provenance.
 * ─────────────────────────────────────────────────────────────────────────────
 */

// ── DB_24节气 — 111 rows × 12 audited day integers per year ───────────────
// Row encoding: [year, jan_day(小寒), feb_day(立春), mar_day(惊蛰),
//                apr_day(清明), may_day(立夏), jun_day(芒种),
//                jul_day(小暑), aug_day(立秋), sep_day(白露),
//                oct_day(寒露), nov_day(立冬), dec_day(大雪)].
// All `_时` cells are blank in the GM; preserved as "" via BLANK_TIME.
const BLANK_TIME = "";

// prettier-ignore
const _24_JIE_QI_ROWS_RAW = [
  [1930,6,5,6,5,6,6,8,8,8,9,8,8],[1931,6,5,7,6,7,7,8,8,8,9,8,8],
  [1932,7,5,6,5,6,6,8,8,8,8,8,7],[1933,6,4,6,5,6,6,8,8,8,8,8,7],
  [1934,6,4,6,5,6,6,8,8,8,9,8,8],[1935,6,5,6,6,6,7,8,8,8,9,8,8],
  [1936,7,5,6,5,6,6,7,8,8,8,7,7],[1937,6,4,6,5,6,6,7,8,8,8,7,7],
  [1938,6,4,6,5,6,6,8,8,8,8,8,8],[1939,6,4,6,6,6,7,8,8,8,9,8,8],
  [1940,7,5,6,5,6,6,7,8,8,8,7,7],[1941,6,4,6,5,6,6,7,8,8,8,7,7],
  [1942,6,4,6,5,6,6,8,8,8,8,8,8],[1943,6,4,6,6,6,7,8,8,8,9,8,8],
  [1944,7,5,6,5,5,6,7,7,8,8,7,7],[1945,6,4,6,5,6,6,7,8,8,8,7,7],
  [1946,6,4,6,5,6,6,8,8,8,8,8,7],[1947,6,4,6,6,6,7,8,8,8,9,8,8],
  [1948,7,5,6,5,5,6,7,7,7,8,7,7],[1949,6,4,6,5,6,6,7,7,7,8,7,7],
  [1950,6,4,6,5,6,6,7,8,8,8,7,7],[1951,6,4,6,6,6,7,8,8,8,9,8,8],
  [1952,7,5,5,5,5,5,7,7,7,8,7,7],[1953,6,4,6,5,6,6,7,7,7,8,7,7],
  [1954,6,4,6,5,6,6,7,8,8,8,7,7],[1955,6,4,6,5,6,6,8,8,8,8,8,8],
  [1956,7,5,6,5,5,6,7,7,7,8,7,7],[1957,6,4,6,5,6,6,7,7,7,8,7,7],
  [1958,6,4,6,5,6,6,7,8,8,8,7,7],[1959,6,4,6,5,6,6,8,8,8,8,8,8],
  [1960,7,5,6,5,5,5,7,7,7,8,7,7],[1961,6,4,6,5,6,6,7,7,7,8,7,7],
  [1962,6,4,6,5,6,6,7,8,8,8,7,7],[1963,6,4,6,5,6,6,8,8,8,8,8,8],
  [1964,7,5,5,4,5,5,7,7,7,8,7,7],[1965,5,3,5,5,5,6,7,7,7,8,7,7],
  [1966,6,4,6,5,6,6,7,8,8,8,7,7],[1967,6,4,6,5,6,6,8,8,8,8,8,7],
  [1968,6,5,5,4,5,5,7,7,7,8,7,6],[1969,5,4,5,5,5,6,7,7,7,8,7,7],
  [1970,6,4,6,5,5,6,7,7,8,8,7,7],[1971,6,4,6,5,6,6,8,8,8,8,7,7],
  [1972,6,5,5,4,5,5,7,7,7,7,7,6],[1973,5,4,5,5,5,5,7,7,7,8,7,7],
  [1974,6,4,6,5,5,6,7,7,7,8,7,7],[1975,6,4,6,5,6,6,8,8,8,8,7,7],
  [1976,6,5,5,4,5,5,7,7,7,7,7,6],[1977,5,4,5,5,5,6,7,7,7,8,7,7],
  [1978,6,4,6,5,5,6,7,7,7,8,7,7],[1979,6,4,6,5,6,6,8,8,8,8,7,7],
  [1980,6,5,5,4,5,5,7,7,7,7,7,6],[1981,6,4,5,5,5,6,7,7,7,8,7,7],
  [1982,6,4,6,5,5,6,7,7,7,8,7,7],[1983,6,4,6,5,6,6,7,8,8,8,7,7],
  [1984,6,4,5,4,5,5,7,7,7,8,7,6],[1985,5,4,6,5,5,6,7,7,7,8,7,7],
  [1986,6,4,6,5,5,6,7,7,7,8,7,7],[1987,6,4,6,5,6,6,7,8,8,8,7,7],
  [1988,6,4,5,4,5,5,7,7,7,8,7,6],[1989,5,4,6,5,5,6,7,7,7,8,7,7],
  [1990,6,4,6,5,5,6,7,7,8,8,7,7],[1991,6,4,6,5,6,6,7,8,8,8,8,7],
  [1992,6,4,5,4,5,5,7,7,7,8,7,6],[1993,5,4,5,4,5,5,7,7,7,8,7,7],
  [1994,5,4,6,5,5,6,7,7,7,8,7,7],[1995,6,4,6,5,6,6,7,8,8,8,7,7],
  [1996,6,4,5,4,5,5,7,7,7,8,7,6],[1997,5,4,5,5,5,6,7,7,7,8,7,7],
  [1998,6,4,6,5,5,6,7,7,7,8,7,7],[1999,6,4,6,5,6,6,7,8,8,8,7,7],
  [2000,6,4,5,4,5,5,7,7,7,8,7,7],[2001,5,4,5,4,5,5,7,7,7,8,7,7],
  [2002,5,4,6,5,5,6,7,7,7,8,7,7],[2003,6,4,6,5,6,6,7,8,8,8,7,7],
  [2004,6,4,5,4,5,5,6,7,7,8,7,6],[2005,5,4,5,5,5,6,7,7,7,8,7,7],
  [2006,5,4,6,5,5,6,7,7,7,8,7,7],[2007,6,4,6,5,6,6,7,8,8,8,7,7],
  [2008,6,4,5,4,5,5,6,7,7,8,7,7],[2009,5,4,5,4,5,5,7,7,7,8,7,7],
  [2010,5,4,6,5,5,6,7,7,7,8,7,7],[2011,6,4,6,5,6,6,7,8,8,8,7,7],
  [2012,6,4,5,4,5,5,6,7,7,7,7,6],[2013,5,4,5,4,5,5,7,7,7,8,7,7],
  [2014,5,4,6,5,5,6,7,7,7,8,7,7],[2015,6,4,6,5,6,6,7,8,8,8,7,7],
  [2016,6,4,5,4,5,5,6,7,7,7,7,6],[2017,5,3,5,4,5,5,7,7,7,8,7,7],
  [2018,5,4,6,5,5,6,7,7,7,8,7,7],[2019,5,4,6,5,6,6,7,8,8,8,7,7],
  [2020,6,4,5,4,5,5,6,7,7,8,7,7],[2021,5,3,5,4,5,5,7,7,7,8,7,7],
  [2022,5,4,6,5,5,6,7,7,7,8,7,7],[2023,5,4,6,5,6,6,7,8,8,8,7,7],
  [2024,6,4,5,4,5,5,6,7,7,8,7,7],[2025,5,3,5,4,5,5,7,7,7,8,7,7],
  [2026,5,4,6,4,5,6,7,7,7,8,7,7],[2027,5,4,6,5,5,6,7,7,8,8,7,7],
  [2028,6,4,5,4,5,5,6,7,7,7,7,6],[2029,5,3,5,4,5,5,7,7,7,8,7,7],
  [2030,5,4,6,5,5,6,7,7,7,8,7,7],[2031,6,4,6,5,5,6,7,7,8,8,7,7],
  [2032,6,4,5,4,5,5,6,7,7,7,7,6],[2033,5,3,5,4,5,5,7,7,7,8,7,7],
  [2034,5,4,6,5,5,6,7,7,7,8,7,7],[2035,5,4,6,5,5,6,7,7,8,8,7,7],
  [2036,6,4,5,4,5,5,6,7,7,7,7,7],[2037,5,3,5,4,5,5,7,7,7,8,7,7],
  [2038,5,4,6,5,5,6,7,7,7,8,7,7],[2039,5,4,6,5,5,6,7,7,8,8,7,7],
  [2040,6,4,5,4,5,5,6,7,7,7,7,6],
];

const JIE_QI_NAMES = Object.freeze([
  String.fromCodePoint(23567, 23506), // 小寒
  String.fromCodePoint(31435, 26149), // 立春
  String.fromCodePoint(24778, 34521), // 惊蛰
  String.fromCodePoint(28165, 26126), // 清明
  String.fromCodePoint(31435, 22799), // 立夏
  String.fromCodePoint(33426, 31181), // 芒种
  String.fromCodePoint(23567, 26257), // 小暑
  String.fromCodePoint(31435, 31179), // 立秋
  String.fromCodePoint(30333, 38706), // 白露
  String.fromCodePoint(23506, 38706), // 寒露
  String.fromCodePoint(31435, 20908), // 立冬
  String.fromCodePoint(22823, 38634), // 大雪
]);

const _24_ROWS = Object.freeze(
  _24_JIE_QI_ROWS_RAW.map(([year, ...days]) =>
    Object.freeze({
      year,
      // 12 audited day integers (Column B/D/F/…/X in Excel, offset 2/4/…/24)
      days: Object.freeze(days.slice()),
      // 12 audited blank times (Column C/E/G/…/Y in Excel, offset 3/5/…/25)
      times: Object.freeze(new Array(12).fill(BLANK_TIME)),
    })
  )
);

const _24_YEAR_INDEX = new Map(_24_ROWS.map((r) => [r.year, r]));

export const DB_24_JIE_QI = Object.freeze({
  codeName: "Sheet27_DB",
  sheetName: String.fromCodePoint(0x44, 0x42, 0x5F, 0x32, 0x34, 33410, 27668), // DB_24节气
  excelUsedRange: "A4:Y115",
  dataRange: "A5:Y115",
  status: "AUTHORITATIVE_DATASET_COMPLETE",
  auditedInBatch: "M02_BATCH_07_1",
  goldenMasterHash:
    "6d97148d708a3dbc84bcec9bdce9facdb815891de077036c9fc118a75e86d500",
  recordCount: 111,
  yearMin: 1930,
  yearMax: 2040,
  jieQiNames: JIE_QI_NAMES,
  rows: _24_ROWS,
});

function throwMissing24(key) {
  const err = new Error(
    `[M02·DB_24节气] year ${JSON.stringify(key)} not found in AUTHORITATIVE_DATASET_COMPLETE`
  );
  err.code = "MISSING_REFERENCE_KEY";
  err.dataset = "DB_24节气";
  err.key = key;
  throw err;
}

/** Exact-match row by integer year (1930..2040). */
export function jieQiRowByYear(year) {
  if (typeof year !== "number" || !Number.isInteger(year)) {
    throw new TypeError("[M02·DB_24节气] year must be an integer");
  }
  const row = _24_YEAR_INDEX.get(year);
  if (!row) throwMissing24(year);
  return row;
}

/** VLOOKUP $B$5, DB_24节气!$A:$Y, colIndex, FALSE — colIndex 2..25.
 *  Even col (2,4,…,24) returns day (int). Odd col (3,5,…,25) returns time ("").
 */
export function jieQiVLookupByColumn(year, excelColumnIndex) {
  const row = jieQiRowByYear(year);
  if (!Number.isInteger(excelColumnIndex) || excelColumnIndex < 2 || excelColumnIndex > 25) {
    throw new RangeError("[M02·DB_24节气] excelColumnIndex must be in 2..25");
  }
  const zeroBased = excelColumnIndex - 2; // 0 → col2, 1 → col3, …
  const isDay = zeroBased % 2 === 0;
  const idx = Math.floor(zeroBased / 2); // 0..11
  return isDay ? row.days[idx] : row.times[idx];
}

/** Excel semantics for E19:E30 offset:
 *  IFERROR(VALUE(LEFT(D<row>,2))/24+VALUE(MID(D<row>,4,2))/1440, 0)
 *  All audited times are blank → offset is deterministically 0. */
export function jieQiTimeOffsetByYearAndIndex(year, jieQiIndex1To12) {
  jieQiRowByYear(year); // validate + fail-closed
  if (!Number.isInteger(jieQiIndex1To12) || jieQiIndex1To12 < 1 || jieQiIndex1To12 > 12) {
    throw new RangeError("[M02·DB_24节气] jieQiIndex1To12 must be 1..12");
  }
  return 0;
}

// ── DB_月令权重 — 12 rows × 5 audited numeric coefficients ────────────────

const M_BRANCH = {
  ZI:   String.fromCodePoint(23376), CHOU:  String.fromCodePoint(19985),
  YIN:  String.fromCodePoint(23493), MAO:   String.fromCodePoint(21359),
  CHEN: String.fromCodePoint(36784), SI:    String.fromCodePoint(24051),
  WU:   String.fromCodePoint(21320), WEI:   String.fromCodePoint(26410),
  SHEN: String.fromCodePoint(30003), YOU:   String.fromCodePoint(37193),
  XU:   String.fromCodePoint(25100), HAI:   String.fromCodePoint(20133),
};
const EL = {
  MU:    String.fromCodePoint(26408), // 木
  HUO:   String.fromCodePoint(28779), // 火
  TU:    String.fromCodePoint(22303), // 土
  JIN:   String.fromCodePoint(37329), // 金
  SHUI:  String.fromCodePoint(27700), // 水
};
const SEASON = {
  DONG:   String.fromCodePoint(20908),                                    // 冬
  SI_JI:  String.fromCodePoint(22235, 23395, 26376),                      // 四季月
  CHUN:   String.fromCodePoint(26149),                                    // 春
  XIA:    String.fromCodePoint(22799),                                    // 夏
  QIU:    String.fromCodePoint(31179),                                    // 秋
};
const DESC_SUFFIX = String.fromCodePoint(
  65288, // （
  ...[], // placeholder — actual description built per row below
);
// Description template: "<branch>月（<season>）：旺相休囚死简化系数，仅供文化参考"
function desc(branch, season) {
  return branch + String.fromCodePoint(26376, 65288) + season + String.fromCodePoint(
    65289, 65306, 26106, 30456, 20241, 22234, 27515, 31616, 21270, 31995, 25968, 65292, 20165, 20379, 25991, 21270, 21442, 32771
  );
}

const _YUE_LING_ROWS = Object.freeze([
  Object.freeze({ monthBranch: M_BRANCH.ZI,   mu: 1.2, huo: 0.5, tu: 0.7, jin: 1.0, shui: 1.5, season: SEASON.DONG,  description: desc(M_BRANCH.ZI,   SEASON.DONG)  }),
  Object.freeze({ monthBranch: M_BRANCH.CHOU, mu: 0.7, huo: 1.0, tu: 1.5, jin: 1.2, shui: 0.5, season: SEASON.SI_JI, description: desc(M_BRANCH.CHOU, SEASON.SI_JI) }),
  Object.freeze({ monthBranch: M_BRANCH.YIN,  mu: 1.5, huo: 1.2, tu: 0.5, jin: 0.7, shui: 1.0, season: SEASON.CHUN,  description: desc(M_BRANCH.YIN,  SEASON.CHUN)  }),
  Object.freeze({ monthBranch: M_BRANCH.MAO,  mu: 1.5, huo: 1.2, tu: 0.5, jin: 0.7, shui: 1.0, season: SEASON.CHUN,  description: desc(M_BRANCH.MAO,  SEASON.CHUN)  }),
  Object.freeze({ monthBranch: M_BRANCH.CHEN, mu: 0.7, huo: 1.0, tu: 1.5, jin: 1.2, shui: 0.5, season: SEASON.SI_JI, description: desc(M_BRANCH.CHEN, SEASON.SI_JI) }),
  Object.freeze({ monthBranch: M_BRANCH.SI,   mu: 1.0, huo: 1.5, tu: 1.2, jin: 0.5, shui: 0.7, season: SEASON.XIA,   description: desc(M_BRANCH.SI,   SEASON.XIA)   }),
  Object.freeze({ monthBranch: M_BRANCH.WU,   mu: 1.0, huo: 1.5, tu: 1.2, jin: 0.5, shui: 0.7, season: SEASON.XIA,   description: desc(M_BRANCH.WU,   SEASON.XIA)   }),
  Object.freeze({ monthBranch: M_BRANCH.WEI,  mu: 0.7, huo: 1.0, tu: 1.5, jin: 1.2, shui: 0.5, season: SEASON.SI_JI, description: desc(M_BRANCH.WEI,  SEASON.SI_JI) }),
  Object.freeze({ monthBranch: M_BRANCH.SHEN, mu: 0.5, huo: 0.7, tu: 1.0, jin: 1.5, shui: 1.2, season: SEASON.QIU,   description: desc(M_BRANCH.SHEN, SEASON.QIU)   }),
  Object.freeze({ monthBranch: M_BRANCH.YOU,  mu: 0.5, huo: 0.7, tu: 1.0, jin: 1.5, shui: 1.2, season: SEASON.QIU,   description: desc(M_BRANCH.YOU,  SEASON.QIU)   }),
  Object.freeze({ monthBranch: M_BRANCH.XU,   mu: 0.7, huo: 1.0, tu: 1.5, jin: 1.2, shui: 0.5, season: SEASON.SI_JI, description: desc(M_BRANCH.XU,   SEASON.SI_JI) }),
  Object.freeze({ monthBranch: M_BRANCH.HAI,  mu: 1.2, huo: 0.5, tu: 0.7, jin: 1.0, shui: 1.5, season: SEASON.DONG,  description: desc(M_BRANCH.HAI,  SEASON.DONG)  }),
]);

const _YUE_LING_INDEX = new Map(_YUE_LING_ROWS.map((r) => [r.monthBranch, r]));

// Element → row key mapping used by Sheet28 VLOOKUP columns 2..6
const ELEMENT_TO_FIELD = Object.freeze({
  [EL.MU]:   "mu",
  [EL.HUO]:  "huo",
  [EL.TU]:   "tu",
  [EL.JIN]:  "jin",
  [EL.SHUI]: "shui",
});

export const DB_YUE_LING_QUAN_ZHONG = Object.freeze({
  codeName: "Sheet28_DB",
  sheetName: String.fromCodePoint(0x44, 0x42, 0x5F, 26376, 20196, 26435, 37325), // DB_月令权重
  excelUsedRange: "A1:H13",
  status: "AUTHORITATIVE_DATASET_COMPLETE",
  auditedInBatch: "M02_BATCH_07_1",
  goldenMasterHash:
    "6d97148d708a3dbc84bcec9bdce9facdb815891de077036c9fc118a75e86d500",
  recordCount: 12,
  elements: Object.freeze(EL),
  rows: _YUE_LING_ROWS,
});

function throwMissingYL(key) {
  const err = new Error(
    `[M02·DB_月令权重] month branch ${JSON.stringify(key)} not found`
  );
  err.code = "MISSING_REFERENCE_KEY";
  err.dataset = "DB_月令权重";
  err.key = key;
  throw err;
}

export function yueLingRowByBranch(monthBranch) {
  if (typeof monthBranch !== "string") {
    throw new TypeError("[M02·DB_月令权重] monthBranch must be a string");
  }
  const row = _YUE_LING_INDEX.get(monthBranch);
  if (!row) throwMissingYL(monthBranch);
  return row;
}

/** VLOOKUP $B$9, DB_月令权重!$A:$F, 2..6, FALSE — returns numeric coefficient. */
export function yueLingWeightByBranchAndElement(monthBranch, element) {
  const row = yueLingRowByBranch(monthBranch);
  const field = ELEMENT_TO_FIELD[element];
  if (!field) {
    const err = new Error(
      `[M02·DB_月令权重] element ${JSON.stringify(element)} not in {木,火,土,金,水}`
    );
    err.code = "MISSING_REFERENCE_KEY";
    throw err;
  }
  return row[field];
}
